/* eslint-disable */
import { InputLabel, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_LOT_NUMBER_SELECTOR_BLUR, UI_LOT_NUMBER_SELECTOR_FOCUS } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * LotNumberSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const LotNumberSelector = ({ actions, classes, onChange = () => {}, defaultLotNumber, isRequired, disabled, mandatoryFieldError }) => {
  const [lotNumber, setLotNumber] = useState(defaultLotNumber && defaultLotNumber.selectedLotNumber ? defaultLotNumber.selectedLotNumber : ``);

  /**
   * Sets order status and informs parent about changes
   * @param {Object} e event
   * @returns {void} void
   */
  const onLotNumberHandle = (e) => {
    setLotNumber(e.target.value);
    let isValid = false;
    if (e.target.value.trim().length <= 10) {
      isValid = true;
    }
    onChange({ isValid, selectedLotNumber: e.target.value });
    return;
  };

  useEffect(() => {
    const isValid = lotNumber.trim().length <= 10;
    onChange({ isValid, selectedLotNumber: lotNumber });
  }, [isRequired]);

  /**
   * Reports analytics
   * @param {Object} e event
   * @returns {void} void
   */
  const onFocusHandle = (e) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `orderLotNumberSelectorFocus`,
        },
      },
      type: UI_LOT_NUMBER_SELECTOR_FOCUS,
    });
    return;
  };

  /**
   * Reports analytics
   * @param {Object} e event
   * @returns {void} void
   */
  const onBlurHandle = (e) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `orderLotNumberSelectorBlur`,
        },
      },
      type: UI_LOT_NUMBER_SELECTOR_BLUR,
    });
    return;
  };

  return (
    <React.Fragment>
      <InputLabel htmlFor="lotNumber" className={classes.inputLabel}>
        Lot Number (Optional)
      </InputLabel>
      <TextField
        name="lotNumber"
        disabled={disabled}
        fullWidth
        error={lotNumber.trim().length > 10 && mandatoryFieldError}
        onChange={onLotNumberHandle}
        onFocus={onFocusHandle}
        onBlur={onBlurHandle}
        value={lotNumber}
        placeholder="Type Lot Number"
        helperText={disabled ? `` : `Optional - Add a lot number for the driver. Max 10 characters.`}
      />
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
LotNumberSelector.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  defaultLotNumber: PropTypes.object,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(LotNumberSelector);
